var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulletPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 7,
    viewBox: "0 0 19 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2478_11432)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.45016C1.28903 3.45808 5.70353 0.827019 7.38104 0.977365C9.05855 1.12771 10.6831 1.61634 12.3429 1.78548C14.6208 2.01099 16.934 1.55996 19 0.526326C17.9229 1.87944 16.6515 3.13859 15.1152 3.79636C13.5613 4.45412 11.6719 4.43533 10.3299 3.3829C9.65892 2.85669 9.1645 2.12375 8.54647 1.52237C7.31041 0.338394 5.56227 -0.206611 3.92007 0.094081C2.94888 0.244427 2.03067 0.714259 1.28903 1.37202C0.44145 2.12375 0.105948 2.91307 0 4.43533V5.45016Z",
    fill: "#135478"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.55389 0.676758C4.43215 2.02987 6.4275 2.38695 8.95259 2.87557C11.9015 3.45816 15.0799 2.53729 17.9052 3.6461C15.6097 3.25144 13.6496 5.41266 11.4071 6.08922C9.69423 6.59664 7.82248 6.20198 6.26858 5.26232C4.73233 4.32265 3.26672 3.15747 2.29553 1.57883L1.55389 0.676758Z",
    fill: "#135478"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2478_11432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 6.33333,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletPoints);
export default __webpack_public_path__ + "static/media/bullet_points.50036fa1971b4ee4c73231ece0f45479.svg";
export { ForwardRef as ReactComponent };